import React, { Component } from 'react'
import NumberFormat from 'react-number-format'

export default class TaxRow extends Component {
	render() {
		return (
			<tr className="cart-item value-row">
				<td colSpan="4">
					<div>{this.props.tax_type.toUpperCase()}</div>
				</td>
				<td><NumberFormat value={this.props.tax} displayType={'text'} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={'$'} /></td>
				<td></td>
			</tr>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/cart/TaxRow.js